import { type AvailableLocale } from '@/config/constants'
import { type User, type Customer } from '@/lib/serializers'

export type SharedProps = {
  currentUser: User | null
  currentCustomer: Customer | null
  authScope: 'user' | 'admin' | null
  locale: AvailableLocale
  localeParam: AvailableLocale | null
  userFilters: { [key: string]: any } | null
  flash: { [key: string]: string }
  errors: { [key: string]: string }
  pagy?: Pagy
}

export type WithSharedProps<T> = SharedProps & T

export const getSharedProps = <TAllProps extends SharedProps>(
  allProps: TAllProps,
): SharedProps => ({
  currentUser: allProps.currentUser,
  currentCustomer: allProps.currentCustomer,
  authScope: allProps.authScope,
  locale: allProps.locale,
  localeParam: allProps.localeParam,
  userFilters: allProps.userFilters,
  flash: allProps.flash,
  errors: allProps.errors,
  pagy: allProps.pagy,
})
